export default __webpack_public_path__ + "phone.e35ff8dd.svg";